module.exports = __webpack_public_path__ + "static/media/1.1fe7af01.jpg";